import React, { useContext } from "react"
import { PCViewContext } from "../Common/PCViewContext"
import Navbar from "react-bootstrap/Navbar"
import * as styles from "./Styles/Header.module.scss"
import "../../styles/layouts"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import logo from "../../images/logo.png"

const Header = (props) => {
  const isPC = useContext(PCViewContext)

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className={cn("header", isPC ? "pc" : "sp")}
    >
      <Navbar.Brand className={styles.logo} as="div">
        <a href="/" className={styles.logoLink}>
          <img src={logo} className={styles.icon} />
        </a>
      </Navbar.Brand>
    </Navbar>
  )
}

export default Header
